import React from 'react';
import { NoSsr } from '@material-ui/core';
import styled from 'styled-components';

import Slider from './material-ui-slider';

// `Slider` (material-ui-slider.jsx) is a forked copy of MUI v4's own Slider source, registered
// internally with `withStyles(styles, { name: 'MuiSlider' })`, so it always carries MUI's own
// stable global slot classes (MuiSlider-root, MuiSlider-mark, MuiSlider-markActive, MuiSlider-rail,
// MuiSlider-track, MuiSlider-trackInverted, MuiSlider-thumb, MuiSlider-valueLabel) regardless of
// this wrapper. None of these keys are in MUI v4's pseudo-class list (checked, disabled, error,
// focused, focusVisible, required, expanded, selected), so they're all correctly component-
// prefixed -- no `Mui-{key}` gotcha here (unlike, e.g., `disabled`/`focusVisible` inside the fork
// itself, which are out of scope for this PR -- see the tracker for material-ui-slider.jsx).
//
// `theme.palette.grey`/`blueGrey`/`white`/`customized` (MUI theme, used by the old withStyles call)
// and `theme.colors.grey`/`blueGrey`/`white`/`customized` (styled-components theme, used below) are
// built from the exact same underlying objects in src/theme/builders/{mui,styled}.js -- confirmed
// by reading both builders, and this mapping is already used identically in the sibling
// `range-slider-plum.tsx`, which converted this exact hook using this exact technique previously.
/**
 * @type {React.FC<{
 *  max: number;
 *  min: number;
 *  onChange: (e: any, value: number) => void;
 *  onChangeCommitted?: (e: any, value: number) => void;
 *  value: number;
 * }>}
 */
const RangeSlider = styled(Slider)`
  &.MuiSlider-root {
    height: 9px;
    padding: 11px 0;
  }

  .MuiSlider-mark {
    background: ${({ theme }) => theme.colors.grey[75]};
    height: 9px;
    width: 2px;
  }

  .MuiSlider-markActive {
    background: ${({ theme }) => theme.colors.white};
  }

  .MuiSlider-rail {
    background: ${({ theme }) => theme.colors.blueGrey[90]};
    border: 1px solid ${({ theme }) => theme.colors.grey[75]};
    border-radius: 7px;
    height: 9px;
    opacity: 1;
  }

  .MuiSlider-track {
    background: ${({ theme }) => theme.customized.colors.buttonsLinks};
    border: none;
    border-radius: 7px;
    height: 9px;
  }

  .MuiSlider-thumb {
    background: url('/icons/slider-handle.svg') no-repeat center center;
    background-size: contain;
    border: none;
    height: 20px;
    margin-top: -6px;
    width: 20px;

    &:active,
    &:focus,
    &:hover {
      box-shadow: 0px 0px 0px 4px rgba(65, 160, 223, 0.35);
    }
  }

  &.MuiSlider-trackInverted .MuiSlider-track {
    background: ${({ theme }) => theme.colors.blueGrey[90]};
    border: 1px solid ${({ theme }) => theme.colors.grey[75]};
  }

  .MuiSlider-valueLabel {
    left: calc(-50% + 4px);
  }
`;

// Supports all the props @material-ui/core/slider does: https://material-ui.com/components/slider/
export default function NoSsrRangeSlider(props) {
  return (
    <NoSsr>
      <RangeSlider {...props} />
    </NoSsr>
  );
}
